__turbopack_context__.v({
  "actionIcon": "Ie2mRq_actionIcon",
  "content": "Ie2mRq_content",
  "embla": "Ie2mRq_embla",
  "emblaContainer": "Ie2mRq_emblaContainer",
  "emblaSlide": "Ie2mRq_emblaSlide",
  "imageContainer": "Ie2mRq_imageContainer",
  "nextBtn": "Ie2mRq_nextBtn",
  "offerElement": "Ie2mRq_offerElement",
  "plus": "Ie2mRq_plus",
  "root": "Ie2mRq_root",
  "square": "Ie2mRq_square",
});
